import { Sentry } from '@/lib/sentry';

/**
 * Capture a silent failure for observability — e.g. an arrival timeout with no thrown error to
 * catch — without surfacing a toast; callers already render their own inline terminal UI state.
 * Mirrors apps/client/lib/observability.ts's captureError so both apps report the same shape.
 * For actually-thrown request errors, prefer src/utils/handleError.ts, which also normalizes
 * known Supabase function error shapes and shows a toast.
 */
export function captureError(error: unknown, context: string): void {
  console.error(`[${context}]`, error);
  Sentry.captureException(error, { tags: { context } });
}
